import {Typography, Box, Card} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';
import useValidateAuth from '@jobseeker/common-core/hooks/useValidateAuth';
import FilterDialog from './internalComponents/filterComp/FilterMobile';
import AppliedMobTile from './internalComponents/AppliedMobileTile';
import {AppliedMobProps} from './types';
import NoAppliedJobs from '@jobseeker/feature-job/components/NoAppliedJobs';
import InfiniteScroll from '@jobseeker/lotus/components/InfiniteScroll';
import Loader from '@jobseeker/lotus/components/Loader';
import {AppliedJobsInterface, AppState} from '@jobseeker/common-core/types';
import {findAppliedJobs} from '@jobseeker/common-core/reducers/job/thunkServices/jobfeed';
import NoJobsFound from '@jobseeker/feature-job/components/NoJobsFound';
import {useRouter} from 'next/router';
import {Image} from '@jobseeker/lotus/components/Image';
import {
  BannerIcon,
  HiristTick,
  LineDivider,
} from '@jobseeker/lotus/assets/icons';
import {useMemo} from 'react';
import AppliedMobTileV2 from './internalComponents/appliedMobileTileV2';
import HiristBannerComponent from '@jobseeker/lotus/components/HiristBanner';

const AppliedMob = ({
  setShowFollowUpProMembershipPrompt,
  setStatusProMembershipPrompt,
  setShowProMembershipPrompt,
  setInsightsOpen,
  userId,
  isStatusChangeCohortUser,
  concat,
  calId,
  slotId,
  remSlots,
  onInfiniteScroll,
  onLoadMore,
  setSelectedValues,
  selectedValues,
}: AppliedMobProps) => {
  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();
  useValidateAuth(dispatch);
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

  const router = useRouter();
  const jobFeedStore = useSelector((state: AppState) => state.job);
  const clearFilter = async () => {
    setSelectedValues([]);
    await router.push(
      {pathname: router.pathname, query: {filters: ''}},
      undefined,
      {shallow: true}
    );

    router.reload();
  };
  const {query} = router;

  const {isPro} = isAppIimjobs
    ? useSelector((state: AppState) => state.auth)
    : {isPro: true};
  const canUseStatusFilters = isPro || !isAppIimjobs;
  const parsedFilters: number[] =
    canUseStatusFilters && query.filters
      ? query.filters
          .toString()
          .split('_')
          .map(Number)
          .filter(num => !isNaN(num)) // Ensure valid numbers
      : [];
  const isQueryParamEmpty = (paramName: string) => {
    const queryParams = new URLSearchParams(router.asPath.split('?')[1]);
    const paramValue = queryParams.get(paramName);
    return paramValue === ''; // Returns true if the query parameter is empty
  };
  const paramName = 'filters';
  const followupremaining = useSelector(
    (state: AppState) => state.user.profile.followUpsRemaining
  );

  const memoizedTiles = useMemo(
    () =>
      (jobFeedStore.jobfeed as AppliedJobsInterface[]).map((j, i) =>
        isAppIimjobs ? (
          <>
            <AppliedMobTile
              calId={calId}
              slotId={slotId}
              remSlots={remSlots}
              key={i}
              hasfollowup={followupremaining ? followupremaining : 0}
              setshowProMembershipPrompt={setShowProMembershipPrompt}
              setShowFollowUpProMembershipPrompt={
                setShowFollowUpProMembershipPrompt
              }
              setShowStatusProMembershipPrompt={setStatusProMembershipPrompt}
              setInsightsbox={setInsightsOpen}
              isPro={isPro}
              isStatusChangeCohortUser={isStatusChangeCohortUser}
              {...j}
            />
            {i !== jobFeedStore.jobfeed.length - 1 ? (
              <Box mb={0.5}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="2"
                  viewBox="0 0 100 2"
                  preserveAspectRatio="none"
                >
                  <path
                    stroke="#7E7E7E"
                    stroke-opacity="0.2"
                    d="M0 1L100 1"
                  ></path>
                </svg>
              </Box>
            ) : (
              <></>
            )}
          </>
        ) : (
          <AppliedMobTileV2
            calId={calId}
            slotId={slotId}
            remSlots={remSlots}
            key={i}
            hasfollowup={followupremaining ? followupremaining : 0}
            setshowProMembershipPrompt={setShowProMembershipPrompt}
            setShowFollowUpProMembershipPrompt={
              setShowFollowUpProMembershipPrompt
            }
            setShowStatusProMembershipPrompt={setStatusProMembershipPrompt}
            setInsightsbox={setInsightsOpen}
            isPro={isPro}
            {...j}
          />
        )
      ),
    [
      jobFeedStore.jobfeed,
      calId,
      slotId,
      remSlots,
      followupremaining,
      setShowProMembershipPrompt,
      setShowFollowUpProMembershipPrompt,
      setStatusProMembershipPrompt,
      setInsightsOpen,
      isPro,
      isStatusChangeCohortUser,
    ]
  );
  const {
    profile: {subscriptions},
  } = useSelector((state: AppState) => state.user);
  const {isLoggedIn} = useSelector((state: AppState) => state.auth);

  return (
    <>
      {isAppIimjobs ? (
        <></>
      ) : (
        <HiristBannerComponent
          data-testid="applied-jobs-mobile-banner"
          showLinkage={true}
          isLoggedIn={isLoggedIn}
          subscriptions={subscriptions}
          userId={userId}
        >
          <>
            <Box width={88} mr={4} alignSelf="center">
              <Image
                src={HiristTick}
                alt="banner-icon"
                width={70}
                height={70}
              />
            </Box>
            <Box alignSelf="center">
              <Typography
                color="white"
                fontSize={16}
                maxWidth={600}
                fontWeight={'bold'}
              >
                Check here all your applied jobs, Job status, follow-ups,
                application status!!
              </Typography>
            </Box>
          </>{' '}
        </HiristBannerComponent>
      )}
      <Card
        data-testid="applied-jobs-mobile-container"
        sx={{
          boxShadow: 1,
          borderRadius: 4,
          backgroundColor: isAppIimjobs ? '#fff' : 'transparent',
          mx: -1,
          pb: 2,
          boxSizing: 'calc(100% - 16px)',
        }}
      >
        <Box data-testid="applied-jobs-mobile-header" display="flex">
          {/* Applied Jobs Title */}
          <Typography
            data-testid="applied-jobs-mobile-title"
            component={true ? 'p' : 'h1'}
            variant="subtitle1"
            sx={{
              display: 'flex',

              width: isAppIimjobs ? 'calc(100% - 48px)' : 'calc(100% - 170px)',
              paddingBottom: {md: 0},
              height: 20,
              mt: 2.75,
              marginLeft: isAppIimjobs ? 1 : 2,
              marginBottom: 2.25,

              wordWrap: 'break-word',
              textTransform: 'capitalize',
            }}
          >
            Applied Jobs
          </Typography>

          {/* Filter Component */}
          {canUseStatusFilters ? (
            <FilterDialog
              data-testid="applied-jobs-mobile-filter"
              setSelectedValues={setSelectedValues}
              selectedValues={selectedValues}
              concat={concat}
            />
          ) : (
            <></>
          )}
        </Box>

        {jobFeedStore.jobfeed.length ? (
          <InfiniteScroll
            data-testid="applied-jobs-mobile-list"
            dataLength={jobFeedStore.jobfeed.length}
            next={onLoadMore}
            hasMore={!!jobFeedStore.loadMoreEnabled}
            // onScroll={onInfiniteScroll}
            loader={
              <Box
                sx={{
                  display: 'flex',
                  textAlign: 'center',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Loader />
              </Box>
            }
            style={{
              scrollbarWidth: 'none',
            }}
          >
            {/* {(jobFeedStore.jobfeed as AppliedJobsInterface[]).map(
              (j, index: number) => (
                <>
                  <AppliedMobTile
                    calId={calId}
                    slotId={slotId}
                    remSlots={remSlots}
                    key={index}
                    hasfollowup={followupremaining ? followupremaining : 0}
                    setshowProMembershipPrompt={setShowProMembershipPrompt}
                    setShowFollowUpProMembershipPrompt={
                      setShowFollowUpProMembershipPrompt
                    }
                    setShowStatusProMembershipPrompt={
                      setStatusProMembershipPrompt
                    }
                    setInsightsbox={setInsightsOpen}
                    isPro={isPro}
                    {...j}
                  />
                  {index !== jobFeedStore.jobfeed.length - 1 ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="100%"
                      height="2"
                      viewBox="0 0 100 2"
                      preserveAspectRatio="none"
                    >
                      <path
                        stroke="#7E7E7E"
                        stroke-opacity="0.2"
                        d="M0 1L100 1"
                      ></path>
                    </svg>
                  ) : (
                    <></>
                  )}
                </>
              )
            )} */}
            {memoizedTiles}
          </InfiniteScroll>
        ) : (canUseStatusFilters &&
            parsedFilters &&
            parsedFilters.length > 0 &&
            parsedFilters?.length < 8) ||
          (canUseStatusFilters && isQueryParamEmpty(paramName)) ? (
          <NoJobsFound
            data-testid="applied-jobs-mobile-no-results"
            clearFilter={clearFilter}
            showBadge={true}
            source={'applied-jobs'}
          />
        ) : (
          <NoAppliedJobs data-testid="applied-jobs-mobile-empty" />
        )}
      </Card>
    </>
  );
};

export default AppliedMob;
